module.exports = __webpack_public_path__ + "img/logo.1ce01067.png";